import { setConsent, useConsent } from '../lib/consent'

/**
 * Asks once, on every page including sign-in and the privacy policy, and
 * stays until answered. Accept and reject are the same size and weight: saying
 * no has to be as easy as saying yes. The choice can be changed later from
 * Section 10 of the privacy policy.
 *
 * Sits under the splash (z-50) so it appears once the intro has played, and
 * under modals and the tour so it never covers something that needs an answer.
 */
export default function CookieBanner() {
  const choice = useConsent()
  if (choice) return null

  const button = 'flex-1 sm:flex-none px-4 py-1.5 text-sm rounded-sm bg-accent text-white hover:brightness-110'

  return (
    <div
      role="region"
      aria-label="Cookie choices"
      className="fixed inset-x-0 bottom-0 z-40 p-3 sm:p-4 pointer-events-none"
    >
      <div className="pointer-events-auto max-w-2xl mx-auto bg-white border border-line rounded shadow-lg p-4 sm:flex sm:items-center sm:gap-5">
        <p className="text-sm text-ink/80 flex-1">
          We use two cookies, to keep you signed in and your plan up to date across your devices — both
          essential. With your OK we’ll also load
          our fonts from Google, which shares your IP address with them. Say no and the app uses your
          device’s fonts instead.{' '}
          {/* A new tab, as from the account menu, so it never interrupts a save. */}
          <a href="/privacy" target="_blank" rel="noopener" className="text-accent underline hover:no-underline whitespace-nowrap">
            Privacy policy
          </a>
        </p>
        <div className="flex gap-2 mt-3 sm:mt-0 shrink-0">
          <button onClick={() => setConsent('rejected')} className={button}>
            Reject
          </button>
          <button onClick={() => setConsent('accepted')} className={button}>
            Accept
          </button>
        </div>
      </div>
    </div>
  )
}
